import { type MutableRefObject } from 'react';

const wait = (ms: number) => new Promise(r => setTimeout(r, ms));

export const retryOperation = <T>(
  operation: () => Promise<T>,
  delay: number,
  retries: number,
  abortRef?: MutableRefObject<boolean>,
): Promise<T> =>
  new Promise((resolve, reject) => {
    if (abortRef?.current) {
      return;
    }

    // TODO: we *might* want to programmatically abort
    // our requests if there are large timeouts in API
    return operation()
      .then(resolve)
      .catch(reason => {
        if (retries <= 0) {
          return reject(reason);
        }

        return wait(delay)
          .then(() => retryOperation(operation, delay, retries - 1, abortRef))
          .then(resolve)
          .catch(reject);
      });
  });
